import React, {useEffect} from "react"
import Styles from "./display.less"
import {connect, useDispatch} from "react-redux"
import ShowAttachment from "../../function/hooks/showAttachment"
import ShowReUpLoad from "../../function/hooks/showReUpLoad"
import ShowDataList from "../../function/hooks/showDataList"
import PreInput from "../../function/hooks/preInputValue"
import {TDAInit} from "../../action/global"
import TDALeftArea from "./leftArea/leftArea"
import TDARightArea from "./rightArea/rightArea"
import {DisplayProps} from "./interface"
import {ReducerState} from "../../reducer/interface/baseInterface"

const Display = (props: DisplayProps) => {
    const dispatch = useDispatch()
    const preInputValue = PreInput()
    const showReUpLoad = ShowReUpLoad()
    const showDataList = ShowDataList()
    const showAttachment = ShowAttachment()
    useEffect(() => {
        TDAInit()
        showAttachment.init()
        showReUpLoad.init()
        showDataList.init()
        preInputValue.init()
        window.onresize = () => {
            dispatch({type: "adaptWindow", payload: true})
        }
        return () => {
            window.onresize = null
            TDAInit()
            showAttachment.init()
            showReUpLoad.init()
            showDataList.init()
            preInputValue.init()
        }
    }, [])
    return (
        <div className={Styles.displayInterface}>
            <div className={Styles.TDA_OUT_BOX}>
                <TDALeftArea />
                <TDARightArea />
            </div>
        </div>
    )
}

export default connect((state: ReducerState) => {
    return {viewType: state.global.viewType}
})(Display)
